export class ListOrganizationIdpsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "idps",
            "baseName": "idps",
            "type": "Array<OrganizationIdp>",
            "format": ""
        },
        {
            "name": "totalCount",
            "baseName": "totalCount",
            "type": "number",
            "format": ""
        },
        {
            "name": "nextToken",
            "baseName": "nextToken",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListOrganizationIdpsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
